import BaseApi from './baseApi';
import IPerson from '../models/IPerson';
import IUser from '../models/IUser';
import IAuthentication from '../models/IAuthentication';
import { EMPTY_GUID } from '../../config/constants';
export default class PersonApi extends BaseApi {
    idUser : string = "";
    constructor() {
        super("dataaccess", "Users");
        let userFromStorage : IAuthentication = JSON.parse(sessionStorage.getItem('user') || '{}');
        this.idUser = userFromStorage.idPerson;
    }

    async GetPersons(idCompany: string) : Promise<IPerson[]> {
        let json : string = "";
        if (idCompany === EMPTY_GUID) {
            json = this.getJsonRead();
        } else {
            json = this.getJsonReadWithIdCompany(idCompany);
        }
        const response = await this.api.post('read', json);
        if (!response) return [];
        if (response.isSuccess) {
            var persons: IPerson[] = [];
            persons = response.data as IPerson[];
            return persons;
        } else {
            this.modelState = response.errorState;
            return [];
        }
    }

    async GetUsers(idCompany: string) : Promise<IUser[]> {
        let json : string = "";
        if (idCompany === EMPTY_GUID) {
            json = this.getJsonReadUser();
        } else {
            json = this.getJsonReadUserWithIdCompany(idCompany);
        }
        const response = await this.api.post('read', json);
        if (!response) return [];
        if (response.isSuccess) {
            var users: IUser[] = [];
            users = response.data as IUser[];
            return users;
        } else {
            this.modelState = response.errorState;
            return [];
        }
    }

    async SavePerson(person: IPerson) : Promise<string> {
        const json = this.getJsonSave(person);
        const response = await this.api.post('save', json);
        if (!response) return "";
        if (response.isSuccess) {
            return response.data as string;
        } else {
            this.modelState = response.errorState;
        }

        return "";
    }

    async UpdatePerson(person: IPerson) : Promise<boolean> {
        const json = this.getJsonUpdate(person);
        const response = await this.api.post('save', json);
        return this.isSuccess(response);
    }

    async DeletePerson(id: string) : Promise<boolean> {
        const json = this.getJsonDelete(id);
        const response = await this.api.post('delete', json);
        return this.isSuccess(response);
    }

    private getJsonDelete(id: string) : any {
        const json = {
            "deleteMetadata": [{
                "Item1": "DeletedBy",
                "Item2": this.idUser
            }, {
                "Item1": "DeletedDate",
                "Item2": new Date()
            }],
            "table": "Persons",
            "conditions": [{
                "Item1": "Persons",
                "Item2": "id",
                "Item3": "=",
                "Item4": id
            }]
        };
        return json;
    }

    private getJsonSave(person: IPerson) : any {
        const json = {
            "fieldsvalues": [{
                "Item1": "Name",
                "Item2": person.name
            }, {
                "Item1": "FirstName",
                "Item2": person.firstName
            }, {
                "Item1": "LastName",
                "Item2": person.lastName
            }, {
                "Item1": "IdListPhonePrefix",
                "Item2": person.idListPhonePrefix
            }, {
                "Item1": "PhoneNumber",
                "Item2": person.phoneNumber
            }, {
                "Item1": "Email",
                "Item2": person.email
            }, {
                "Item1": "IdCompany",
                "Item2": person.idCompany
            }, {
                "Item1": "IdUser",
                "Item2": person.idUser
            }, {
                "Item1": "Deleted",
                "Item2": 0
            }, {
                "Item1": "CreatedBy",
                "Item2": this.idUser
            }, {
                "Item1": "CreatedDate",
                "Item2": new Date()
            }],
            "table": "Persons"
        };
        return json;
    }

    private getJsonUpdate(person: IPerson) : any {
        const json = {
            "fieldsvalues": [{
                "Item1": "Name",
                "Item2": person.name
            }, {
                "Item1": "FirstName",
                "Item2": person.firstName
            }, {
                "Item1": "LastName",
                "Item2": person.lastName
            }, {
                "Item1": "IdListPhonePrefix",
                "Item2": person.idListPhonePrefix
            }, {
                "Item1": "PhoneNumber",
                "Item2": person.phoneNumber
            }, {
                "Item1": "Email",
                "Item2": person.email
            }, {
                "Item1": "IdCompany",
                "Item2": person.idCompany
            }, {
                "Item1": "IdUser",
                "Item2": person.idUser
            }, {
                "Item1": "ModifiedBy",
                "Item2": this.idUser
            }, {
                "Item1": "ModifiedDate",
                "Item2": new Date()
            }],
            "table": "Persons",
            "keyvalue": person.id
        };
        return json;
    }

    private getJsonRead() : any {
        const json = {
            "fields": [{
                "Item1": "Persons",
                "Item2": "id"
            }, {
                "Item1": "Persons",
                "Item2": "name"
            }, {
                "Item1": "Persons",
                "Item2": "firstName"
            }, {
                "Item1": "Persons",
                "Item2": "lastName"
            }, {
                "Item1": "Persons",
                "Item2": "idListPhonePrefix"
            }, {
                "Item1": "ListPhonePrefixes",
                "Item2": "prefix"
            }, {
                "Item1": "Persons",
                "Item2": "phoneNumber"
            }, {
                "Item1": "Persons",
                "Item2": "email"
            }, {
                "Item1": "Persons",
                "Item2": "idCompany"
            }, {
                "Item1": "Companies",
                "Item2": "name as companyName"
            }, {
                "Item1": "Persons",
                "Item2": "idUser"
            }, {
                "Item1": "Users",
                "Item2": "userName"
            }, {
                "Item1": "Users",
                "Item2": "idRole"
            }, {
                "Item1": "Roles",
                "Item2": "roleName"
            }],
            "tables": [{
                "Item1": "Persons"
            }, {
                "Item1": "ListPhonePrefixes"
            }, {
                "Item1": "Companies"
            }, {
                "Item1": "Users"
            }, {
                "Item1": "Roles"
            }],
            "joins": [{
                "Item1": "Persons",
                "Item2": "IdListPhonePrefix",
                "Item3": "ListPhonePrefixes",
                "Item4": "Id"
            }, {
                "Item1": "Persons",
                "Item2": "IdCompany",
                "Item3": "Companies",
                "Item4": "Id"
            }, {
                "Item1": "Persons",
                "Item2": "IdUser",
                "Item3": "Users",
                "Item4": "Id"
            }, {
                "Item1": "Users",
                "Item2": "IdRole",
                "Item3": "Roles",
                "Item4": "Id"
            }],
            "conditions": [{
                "Item1": "Persons",
                "Item2": "Deleted",
                "Item3": "=",
                "Item4": "0"
            }]
        };
        return json;
    }

    private getJsonReadWithIdCompany(idCompany: string) : any {
        const json = {
            "fields": [{
                "Item1": "Persons",
                "Item2": "id"
            }, {
                "Item1": "Persons",
                "Item2": "name"
            }, {
                "Item1": "Persons",
                "Item2": "firstName"
            }, {
                "Item1": "Persons",
                "Item2": "lastName"
            }, {
                "Item1": "Persons",
                "Item2": "idListPhonePrefix"
            }, {
                "Item1": "ListPhonePrefixes",
                "Item2": "prefix"
            }, {
                "Item1": "Persons",
                "Item2": "phoneNumber"
            }, {
                "Item1": "Persons",
                "Item2": "email"
            }, {
                "Item1": "Persons",
                "Item2": "idCompany"
            }, {
                "Item1": "Companies",
                "Item2": "name as companyName"
            }, {
                "Item1": "Persons",
                "Item2": "idUser"
            }, {
                "Item1": "Users",
                "Item2": "userName"
            }, {
                "Item1": "Users",
                "Item2": "idRole"
            }, {
                "Item1": "Roles",
                "Item2": "roleName"
            }],
            "tables": [{
                "Item1": "Persons"
            }, {
                "Item1": "ListPhonePrefixes"
            }, {
                "Item1": "Companies"
            }, {
                "Item1": "Users"
            }, {
                "Item1": "Roles"
            }],
            "joins": [{
                "Item1": "Persons",
                "Item2": "IdListPhonePrefix",
                "Item3": "ListPhonePrefixes",
                "Item4": "Id"
            }, {
                "Item1": "Persons",
                "Item2": "IdCompany",
                "Item3": "Companies",
                "Item4": "Id"
            }, {
                "Item1": "Persons",
                "Item2": "IdUser",
                "Item3": "Users",
                "Item4": "Id"
            }, {
                "Item1": "Users",
                "Item2": "IdRole",
                "Item3": "Roles",
                "Item4": "Id"
            }],
            "conditions": [{
                "Item1": "Persons",
                "Item2": "Deleted",
                "Item3": "=",
                "Item4": "0",
                "Item5": "AND"
            }, {
                "Item1": "Persons",
                "Item2": "idCompany",
                "Item3": "=",
                "Item4": idCompany,
                "Item5": "AND"
            }, {
                "Item1": "Roles",
                "Item2": "roleName",
                "Item3": "<>",
                "Item4": "Administrator"
            }]
        };
        return json;
    }

    private getJsonReadUser() : any {
        const json = {
            "fields": [{
                "Item1": "Users",
                "Item2": "id"
            }, {
                "Item1": "Users",
                "Item2": "userName"
            }, {
                "Item1": "Users",
                "Item2": "idRole"
            }, {
                "Item1": "Users",
                "Item2": "roleName"
            }],
            "tables": [{
                "Item1": "Users"
            }, {
                "Item1": "Roles"
            }],
            "joins": [{
                "Item1": "Users",
                "Item2": "IdRole",
                "Item3": "Roles",
                "Item4": "Id"
            }],
            "conditions": [{
                "Item1": "Users",
                "Item2": "Deleted",
                "Item3": "=",
                "Item4": "0"
            }]
        };
        return json;
    }

    private getJsonReadUserWithIdCompany(idCompany: string) : any {
        const json = {
            "fields": [{
                "Item1": "Users",
                "Item2": "id"
            }, {
                "Item1": "Users",
                "Item2": "userName"
            }, {
                "Item1": "Users",
                "Item2": "idRole"
            }, {
                "Item1": "Users",
                "Item2": "roleName"
            }],
            "tables": [{
                "Item1": "Users"
            }, {
                "Item1": "Roles"
            }, {
                "Item1": "Persons"
            }],
            "joins": [{
                "Item1": "Users",
                "Item2": "IdRole",
                "Item3": "Roles",
                "Item4": "Id"
            }, {
                "Item1": "Users",
                "Item2": "Id",
                "Item3": "Persons",
                "Item4": "IdUser"
            }],
            "conditions": [{
                "Item1": "Users",
                "Item2": "Deleted",
                "Item3": "=",
                "Item4": "0"
            }, {
                "Item1": "Persons",
                "Item2": "idCompany",
                "Item3": "=",
                "Item4": idCompany
            }]
        };
        return json;
    }
}
